import { z } from "zod";

export enum ReportRunPeriodsTypeEnum {
    RUN_DAILY = 1,
}

export const ReportRunPeriodsTypeEnumSchema = z.nativeEnum(ReportRunPeriodsTypeEnum);
export type ReportRunPeriodsTypeEnumSchema = z.infer<typeof ReportRunPeriodsTypeEnumSchema>;